import styled, { keyframes } from 'styled-components';
import FormattedMessage from './FormattedMessage'; // Importar o novo componente

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: none; }
`;

const HistoryContainer = styled.div`
  flex-grow: 1; /* Ocupa o espaço disponível */
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Espaçamento menor entre balões */
  padding: 1rem; /* Padding nas laterais e topo/base */
  overflow-y: auto; /* Mantém scroll */
  /* Remover max-height e margin */
`;

const MessageBubble = styled.div`
  align-self: ${({ from }) => (from === 'user' ? 'flex-end' : 'flex-start')};
  background: ${({ from }) => (from === 'user' ? '#005c4b' : '#202c33')}; /* Cores WhatsApp Dark */
  color: #e9edef; /* Texto claro */
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  /* Adicionar borda específica para o "rabicho" do balão */
  border-top-left-radius: ${({ from }) => (from === 'ia' ? '0' : '0.5rem')};
  border-top-right-radius: ${({ from }) => (from === 'user' ? '0' : '0.5rem')};
  max-width: 75%; /* Largura máxima */
  font-size: 0.95rem; /* Tamanho de fonte */
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); /* Sombra sutil */
  animation: ${fadeIn} 0.3s ease-out; /* Animação */
  word-wrap: break-word; /* Quebra de palavras longas */
  position: relative; /* Necessário para pseudo-elementos se quisermos adicionar o "tick" depois */

  /* Adicionar um pouco de margem inferior */
  margin-bottom: 0.2rem;
`;

export default function ChatHistory({ history }) {
  return (
    <HistoryContainer>
      {history.map((msg, idx) => (
        <MessageBubble key={idx} from={msg.from}>
          {/* Usar o componente FormattedMessage para renderizar o texto */}
          <FormattedMessage content={msg.text} />
        </MessageBubble>
      ))}
    </HistoryContainer>
  );
}
